export default __webpack_public_path__ + "static/media/3.8a41b40b.svg";